var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalisisspasial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,10.25c-.78,0-1.46,.4-1.87,1h-2.09c-.54-1.73-2.14-3-4.04-3-.55,0-1.08,.11-1.56,.31l-1.05-1.57c.53-.5,.86-1.2,.86-1.99,0-1.52-1.23-2.75-2.75-2.75s-2.75,1.23-2.75,2.75,1.23,2.75,2.75,2.75c.19,0,.38-.02,.56-.06l1.11,1.66c-.86,.78-1.42,1.89-1.42,3.15,0,.9,.29,1.73,.77,2.42l-.82,.82c-.5-.31-1.07-.49-1.7-.49-1.79,0-3.25,1.46-3.25,3.25s1.46,3.25,3.25,3.25,3.25-1.46,3.25-3.25c0-.62-.19-1.2-.49-1.7l.82-.82c.69,.48,1.52,.77,2.42,.77,2.26,0,4.09-1.77,4.22-4h1.55c.13,1.12,1.07,2,2.22,2,1.24,0,2.25-1.01,2.25-2.25s-1.01-2.25-2.25-2.25Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "h"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "i"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "j"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "k"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "l"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "m"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "n"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "o"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "p"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "q"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "r"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "s"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "t"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "u"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalisisspasial);
export default __webpack_public_path__ + "static/media/analisisspasial.c278e425e6c1891d206ebe63875444b3.svg";
export { ForwardRef as ReactComponent };